import React, { useContext, useEffect, useState } from 'react';
import { Fade, FormControl, Grid, IconButton, Input, InputAdornment, InputLabel, Tooltip, makeStyles } from '@material-ui/core';
import { AccountCircle, Lock, Visibility, VisibilityOff } from '@material-ui/icons';
import { useHistory, useParams } from 'react-router-dom';
import { ROUTES } from '../../constants/RoutingConstants';
import { LoginAPI } from '../../services/LoginAPI';
import { AppContext } from '../../contexts/AppContext';
import RegexTextField from '../../components/UI/RegexTextField';
import CircularCountdown from '../../components/UI/CircularCountdown';
import AnimatedButton from '../../components/UI/AnimatedButton';
import { isValidPassword } from '../../utils/MiscellaneousUtils';

import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    height: '100vh',
    background: `radial-gradient(at top left, #FF00FF12 40%, ${theme.palette.primary.main} 100%)`,
  },
  loginCard: {
    display: 'flex',
    width: 380,
    height: 335,
    borderRadius: 10,
    padding: 10,
    overflow: 'hidden',
    boxShadow: '0 0 30px 0 rgba(0,0,0,.5)',
    backgroundColor: 'white',
    '@supports (backdrop-filter: blur(10px))': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      backdropFilter: 'blur(10px)',
    },
  },
  loginForm: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '1em',
    padding: '0 0.5em 0 1em',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  loginField: {
    width: '100%',
  },
  loginManagmentOptions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    width: '100%',
  },
  loginManagmentBtn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loginBtn: {
    margin: '2em 0 1em 0',
    borderRadius: 10,
  },
  fillBlankSpace: {
    height: '5em',
  },
  messageWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    rowGap: '1em',
    position: 'absolute',
    textAlign: 'center',
    padding: '0 1em 0 1em',
    top: '50%',
    transition: '1s !important',
  },
}));

const CuitInput = ({ fieldValue, setFieldValue }) => {
  const classes = useStyles();
  const [value, setValue] = useState(fieldValue);
  const [focus, setFocus] = useState(false);
  const onlyNumbers = /[^0-9]/gi;
  const { type } = useParams();

  return (
    <div className={classes.loginField}>
      <Grid container spacing={1} alignItems="flex-end">
        <Grid item>
          <AccountCircle color={focus ? 'primary' : 'action'} />
        </Grid>
        <Grid item xs={10}>
          <RegexTextField
            //regex={onlyNumbers}
            fullWidth
            id="input-with-icon-grid"
            label={(type ? (type == 'I' ? 'CUIT/Email' : 'Código Proveedor'): 'CUIT')}
            value={value}
            onChange={event => setValue(event.target.value)}
            onBlur={() => setFieldValue(value)}
            onBlurCapture={() => setFocus(false)}
            onFocus={() => setFocus(true)}
          />
        </Grid>
      </Grid>
    </div>
  );
};

const PasswordInput = ({ fieldValue, setFieldValue }) => {
  const classes = useStyles();
  const [value, setValue] = useState(fieldValue);
  const [showPassword, setShowPassword] = useState(false);
  const [focus, setFocus] = useState(false);

  return (
    <div className={classes.loginField}>
      <Grid container spacing={1} alignItems="flex-end">
        <Grid item>
          <Lock color={focus ? 'primary' : 'action'} />
        </Grid>
        <Grid item xs={10}>
          <FormControl className={classes.loginField}>
            <InputLabel htmlFor="standard-adornment-password">Contraseña</InputLabel>
            <Input
              id="standard-adornment-password"
              type={showPassword ? 'text' : 'password'}
              value={value}
              onChange={event => setValue(event.target.value)}
              onBlur={() => setFieldValue(value)}
              onBlurCapture={() => setFocus(false)}
              onFocus={() => setFocus(true)}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="Muestra/Oculta Contraseña"
                    onClick={() => setShowPassword(!showPassword)}
                    onMouseDown={event => event.preventDefault()}>
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                  <Tooltip
                    
                    title={
                      <div style={{ textAlign: 'left' }}>
                        <ul style={{ textAlign: 'left', fontSize: '10px', paddingLeft: '12px'}}>
                        <li>Debe tener al menos 8 caracteres.</li>
                        <li>Debe tener al menos 1 mayúscula.</li>
                        <li>Debe tener al menos 1 minúscula.</li>
                        <li>Debe tener al menos 1 caracter especial.</li>
                      </ul>
                      </div>
                      
                    }
                    style={{ textAlign: 'left'}}
                    placement='right'
                  >
                    <HelpOutlineOutlinedIcon style={{ fontSize: 20 }}/>
                  </Tooltip>
                </InputAdornment>
              }
            />            
          </FormControl>
        </Grid>
      </Grid>
    </div>
  );
};

const SuccessMessage = ({ showMessage, forgotPassword, redirectLogin }) => {
  const classes = useStyles();

  return (
    <Fade timeout={500} in={showMessage}>
      <div className={classes.messageWrapper}>
        {forgotPassword ? (
          <div>
            El cambio de password se realizó con éxito.<br></br>
            <br></br>
            Puede ingresar normalmente al portal con su nueva password.
          </div>
        ) : (
          <div>
            La registración se completó con éxito.<br></br>
            <br></br>
            Puede ingresar normalmente al portal con su nueva password.
          </div>
        )}
        <CircularCountdown
          label="Redireccionando al login..."
          isPlaying={showMessage}
          size={30}
          strokeWidth={3}
          colors={[
            ['#000000', 0.33],
            ['#2176CD', 0.33],
            ['#009E2A', 0.33],
          ]}
          duration={5}
          onComplete={redirectLogin}
        />
      </div>
    </Fade>
  );
};

const PasswordManagement = ({ forgotPassword }) => {
  const classes = useStyles();
  const { showError, showWarning } = useContext(AppContext);
  const [cuit, setCuit] = useState('');
  const [password, setPassword] = useState('');
  const [cardIn, setCardIn] = useState(false);
  const [fadeIn, setFadeIn] = useState(true);
  const [showMessage, setShowMessage] = useState(false);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const { token } = useParams();
  const { type } = useParams();

  /* INICIO FIX para issue con Chrome. Autocomplete de user y password no dispara onChange */
  useEffect(() => {
    setCuit(document.getElementById('input-with-icon-grid').value);
    setPassword(document.getElementById('standard-adornment-password').value);
  }, [cuit, password]);
  /* FIN FIX para issue con Chrome. Autocomplete de user y password no dispara onChange */

  const validate = () => {
    let errors = [];
    const errorMessages = [];
    let i = 0;

    if ((errors[i++] = cuit.isBlank())) {
      errorMessages.push('Debe completar el CUIT');
    }else if ((errors[i++] = true && type === 'I' && !(/^(\d+|[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/).test(cuit))) {
      errorMessages.push(`Debe ingresar un CUIT/Email de Proveedor válido`);      
    }

    if ((errors[i++] = password.isBlank())) {
      errorMessages.push('Debe completar la contraseña');
    } else if ((errors[i++] = !isValidPassword(password))) {
      errorMessages.push('La contraseña debe tener al menos 8 caracteres, mayúsculas, minúsculas y caracteres especiales');
    }

    const hasErrors = errors.some(e => e);

    hasErrors && showWarning(errorMessages);

    return !hasErrors;
  };

  const executeTransition = action => {
    setCardIn(false);
    setTimeout(() => {
      setFadeIn(false);
      setTimeout(() => action(), 250);
    }, 500);
  };

  const redirectLogin = () => {
    executeTransition(() => history.push(ROUTES.LOGIN.SUPPLIER));
  };

  const handlePasswordChange = () => {
    if (validate()) {
      setLoading(true);
      const serviceCall = forgotPassword
        ? LoginAPI.changePassword(cuit, password, token, type)
        : LoginAPI.confirmSigningUp(cuit, password, token, type);

      serviceCall
        .then(res => setShowMessage(true))
        .catch(({ response: { data } }) => {
          setLoading(false);
          const message = forgotPassword
            ? 'No se pudo realizar el cambio de contraseña'
            : 'No se pudo completar el proceso de registración';
          const errorMessages = data.errors ? Object.values(data.errors) : [data];
          showError(message, errorMessages);
        });
    }
  };

  return (
    <Fade in={fadeIn} timeout={500} onEntered={() => setCardIn(true)}>
      <div className={classes.root}>
        <Fade timeout={1000} in={cardIn}>
          <div className={classes.loginCard}>
            <div style={{ position: 'relative' }} className={classes.loginForm}>
              <SuccessMessage showMessage={showMessage} forgotPassword={forgotPassword} redirectLogin={redirectLogin} />
              <img alt="" src={process.env.PUBLIC_URL + '/images/logo.png'} width="55%" />
              <Fade timeout={1000} in={!showMessage} appear={true}>
                <div className={classes.loginForm}>
                  <CuitInput fieldValue={cuit} setFieldValue={setCuit} />
                  <PasswordInput fieldValue={password} setFieldValue={setPassword} />                 
                  <AnimatedButton
                    className={classes.loginBtn}
                    variant="contained"
                    color="primary"
                    onClick={handlePasswordChange}
                    loading={loading}>
                    {forgotPassword ? 'Cambiar password' : 'Confirmar registración'}
                  </AnimatedButton>
                </div>
              </Fade>
            </div>
          </div>
        </Fade>
      </div>
    </Fade>
  );
};

export default PasswordManagement;
